(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
function corslite(url, callback, cors) {
    var sent = false;

    if (typeof window.XMLHttpRequest === 'undefined') {
        return callback(Error('Browser not supported'));
    }

    if (typeof cors === 'undefined') {
        var m = url.match(/^\s*https?:\/\/[^\/]*/);
        cors = m && (m[0] !== location.protocol + '//' + location.hostname +
                (location.port ? ':' + location.port : ''));
    }

    var x = new window.XMLHttpRequest();

    function isSuccessful(status) {
        return status >= 200 && status < 300 || status === 304;
    }

    if (cors && !('withCredentials' in x)) {
        // IE8-9
        x = new window.XDomainRequest();

        // Ensure callback is never called synchronously, i.e., before
        // x.send() returns (this has been observed in the wild).
        // See https://github.com/mapbox/mapbox.js/issues/472
        var original = callback;
        callback = function() {
            if (sent) {
                original.apply(this, arguments);
            } else {
                var that = this, args = arguments;
                setTimeout(function() {
                    original.apply(that, args);
                }, 0);
            }
        }
    }

    function loaded() {
        if (
            // XDomainRequest
            x.status === undefined ||
            // modern browsers
            isSuccessful(x.status)) callback.call(x, null, x);
        else callback.call(x, x, null);
    }

    // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
    // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).
    if ('onload' in x) {
        x.onload = loaded;
    } else {
        x.onreadystatechange = function readystate() {
            if (x.readyState === 4) {
                loaded();
            }
        };
    }

    // Call the callback with the XMLHttpRequest object as an error and prevent
    // it from ever being called again by reassigning it to `noop`
    x.onerror = function error(evt) {
        // XDomainRequest provides no evt parameter
        callback.call(this, evt || true, null);
        callback = function() { };
    };

    // IE9 must have onprogress be set to a unique function.
    x.onprogress = function() { };

    x.ontimeout = function(evt) {
        callback.call(this, evt, null);
        callback = function() { };
    };

    x.onabort = function(evt) {
        callback.call(this, evt, null);
        callback = function() { };
    };

    // GET is the only supported HTTP Verb by XDomainRequest and is the
    // only one supported here.
    x.open('GET', url, true);

    // Send the request. Sending data is not supported.
    x.send(null);
    sent = true;

    return x;
}

if (typeof module !== 'undefined') module.exports = corslite;

},{}],2:[function(_dereq_,module,exports){
'use strict';

/**
 * Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
 *
 * Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
 * by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)
 *
 * @module polyline
 */

var polyline = {};

function py2_round(value) {
    // Google's polyline algorithm uses the same rounding strategy as Python 2, which is different from JS for negative values
    return Math.floor(Math.abs(value) + 0.5) * Math.sign(value);
}

function encode(current, previous, factor) {
    current = py2_round(current * factor);
    previous = py2_round(previous * factor);
    var coordinate = current - previous;
    coordinate <<= 1;
    if (current - previous < 0) {
        coordinate = ~coordinate;
    }
    var output = '';
    while (coordinate >= 0x20) {
        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
        coordinate >>= 5;
    }
    output += String.fromCharCode(coordinate + 63);
    return output;
}

/**
 * Decodes to a [latitude, longitude] coordinates array.
 *
 * This is adapted from the implementation in Project-OSRM.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Array}
 *
 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
 */
polyline.decode = function(str, precision) {
    var index = 0,
        lat = 0,
        lng = 0,
        coordinates = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, precision || 5);

    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while (index < str.length) {

        // Reset shift, result, and byte
        byte = null;
        shift = 0;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        shift = result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        lat += latitude_change;
        lng += longitude_change;

        coordinates.push([lat / factor, lng / factor]);
    }

    return coordinates;
};

/**
 * Encodes the given [latitude, longitude] coordinates array.
 *
 * @param {Array.<Array.<Number>>} coordinates
 * @param {Number} precision
 * @returns {String}
 */
polyline.encode = function(coordinates, precision) {
    if (!coordinates.length) { return ''; }

    var factor = Math.pow(10, precision || 5),
        output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);

    for (var i = 1; i < coordinates.length; i++) {
        var a = coordinates[i], b = coordinates[i - 1];
        output += encode(a[0], b[0], factor);
        output += encode(a[1], b[1], factor);
    }

    return output;
};

function flipped(coords) {
    var flipped = [];
    for (var i = 0; i < coords.length; i++) {
        flipped.push(coords[i].slice().reverse());
    }
    return flipped;
}

/**
 * Encodes a GeoJSON LineString feature/geometry.
 *
 * @param {Object} geojson
 * @param {Number} precision
 * @returns {String}
 */
polyline.fromGeoJSON = function(geojson, precision) {
    if (geojson && geojson.type === 'Feature') {
        geojson = geojson.geometry;
    }
    if (!geojson || geojson.type !== 'LineString') {
        throw new Error('Input must be a GeoJSON LineString');
    }
    return polyline.encode(flipped(geojson.coordinates), precision);
};

/**
 * Decodes to a GeoJSON LineString geometry.
 *
 * @param {String} str
 * @param {Number} precision
 * @returns {Object}
 */
polyline.toGeoJSON = function(str, precision) {
    var coords = polyline.decode(str, precision);
    return {
        type: 'LineString',
        coordinates: flipped(coords)
    };
};

if (typeof module === 'object' && module.exports) {
    module.exports = polyline;
}

},{}],48:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	module.exports = L.Class.extend({
		options: {
			timeout: 500,
			minLength: 3,
			blurTimeout: 100,
			noResultsMessage: 'No results found.'
		},

		initialize: function(elem, callback, context, options) {
			L.setOptions(this, options);

			this._elem = elem;
			this._resultFn = options.resultFn ? L.Util.bind(options.resultFn, options.resultContext) : null;
			this._autocomplete = options.autocompleteFn ? L.Util.bind(options.autocompleteFn, options.autocompleteContext) : null;
			this._selectFn = L.Util.bind(callback, context);
			this._container = L.DomUtil.create('div', 'leaflet-routing-geocoder-result');
			this._resultTable = L.DomUtil.create('table', '', this._container);

			// TODO: looks a bit like a kludge to register same for input and keypress -
			// browsers supporting both will get duplicate events; just registering
			// input will not catch enter, though.
			L.DomEvent.addListener(this._elem, 'input', this._keyPressed, this);
			L.DomEvent.addListener(this._elem, 'keypress', this._keyPressed, this);
			L.DomEvent.addListener(this._elem, 'keydown', this._keyDown, this);
			L.DomEvent.addListener(this._elem, 'blur', function() {
				if (this._isOpen) {
					this.close();
				}
			}, this);
			L.DomEvent.addListener(this._elem, 'click', this._click, this);
                        //L.DomEvent.addListener(this._elem, 'dblclick', this._click, this);
		},

		_click: function(e) {
			var el = e.target;
			if (el.value) return;
			if (navigator.geolocation == undefined) return;

			var success = function(p) {
				map.off('locationfound', success);
                                var els = [];
                                els[0] = { name: "Current location", center: p.latlng };

				this._complete(L.Util.bind(function(inputText, cb, context) {
	                                cb.call(context,els);
				},this), false, true);
                        };

			map.locate({ maximumAge: 180*1000, timeout: 3*1000 });
			map.on('locationfound', success, this);
		},

		close: function() {
			L.DomUtil.removeClass(this._container, 'leaflet-routing-geocoder-result-open');
			this._isOpen = false;
		},

		_open: function() {
			var rect = this._elem.getBoundingClientRect();
			if (!this._container.parentElement) {
				// See notes section under https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollX
				// This abomination is required to support all flavors of IE
				var scrollX = (window.pageXOffset !== undefined) ? window.pageXOffset
					: (document.documentElement || document.body.parentNode || document.body).scrollLeft;
				var scrollY = (window.pageYOffset !== undefined) ? window.pageYOffset
					: (document.documentElement || document.body.parentNode || document.body).scrollTop;
				this._container.style.left = (rect.left + scrollX) + 'px';
				this._container.style.top = (rect.bottom + scrollY) + 'px';
				this._container.style.width = (rect.right - rect.left) + 'px';
				document.body.appendChild(this._container);
			}

			L.DomUtil.addClass(this._container, 'leaflet-routing-geocoder-result-open');
			this._isOpen = true;
		},

		_setResults: function(results) {
			var i,
			    tr,
			    td,
			    text;

			delete this._selection;
			this._results = results;

			while (this._resultTable.firstChild) {
				this._resultTable.removeChild(this._resultTable.firstChild);
			}

			for (i = 0; i < results.length; i++) {
				tr = L.DomUtil.create('tr', '', this._resultTable);
				tr.setAttribute('data-result-index', i);
				td = L.DomUtil.create('td', '', tr);
				text = document.createTextNode(results[i].name);
				td.appendChild(text);
				// mousedown + click because:
				// http://stackoverflow.com/questions/10652852/jquery-fire-click-before-blur-event
				L.DomEvent.addListener(td, 'mousedown', L.DomEvent.preventDefault);
				L.DomEvent.addListener(td, 'click', this._createClickListener(results[i]));
			}

			if (!i) {
				tr = L.DomUtil.create('tr', '', this._resultTable);
				td = L.DomUtil.create('td', 'leaflet-routing-geocoder-no-results', tr);
				td.innerHTML = this.options.noResultsMessage;
			}

			this._open();

			if (results.length > 0) {
				// Select the first entry
				this._select(1);
			}
		},

		_createClickListener: function(r) {
			var resultSelected = this._resultSelected(r);
			return L.bind(function() {
				this._elem.blur();
				resultSelected();
			}, this);
		},

		_resultSelected: function(r) {
			return L.bind(function() {
				this.close();
				this._elem.value = r.name;
				this._lastCompletedText = r.name;
				this._selectFn(r);
			}, this);
		},

		_keyPressed: function(e) {
			var index;
			clearTimeout(this._timer);
			this._requestId = (this._requestId || 0) + 1;
			if (this._request) {
				this._request.abort();
				this._request = null;
			}
			if (this._elem.value.trim().length < this.options.minLength && e.keyCode !== 13) {
				this.close();
				return;
			}

			if (this._isOpen && e.keyCode === 13 && this._selection) {
				index = parseInt(this._selection.getAttribute('data-result-index'), 10);
				this._resultSelected(this._results[index])();
				L.DomEvent.preventDefault(e);
				return;
			}

			if (e.keyCode === 13) {
				L.DomEvent.preventDefault(e);
				this._complete(this._resultFn, true);
				return;
			}

			if (this._autocomplete && document.activeElement === this._elem) {
				if (this._timer) {
					clearTimeout(this._timer);
				}
				this._timer = setTimeout(L.Util.bind(function() { this._complete(this._autocomplete); }, this),
					this.options.timeout);
				return;
			}

			this._unselect();
		},

		_select: function(dir) {
			var sel = this._selection;
			if (sel) {
				L.DomUtil.removeClass(sel.firstChild, 'leaflet-routing-geocoder-selected');
				sel = sel[dir > 0 ? 'nextSibling' : 'previousSibling'];
			}
			if (!sel) {
				sel = this._resultTable[dir > 0 ? 'firstChild' : 'lastChild'];
			}

			if (sel) {
				L.DomUtil.addClass(sel.firstChild, 'leaflet-routing-geocoder-selected');
				this._selection = sel;
			}
		},

		_unselect: function() {
			if (this._selection) {
				L.DomUtil.removeClass(this._selection.firstChild, 'leaflet-routing-geocoder-selected');
			}
			delete this._selection;
		},

		_keyDown: function(e) {
			if (this._isOpen) {
				switch (e.keyCode) {
				// Escape
				case 27:
					this.close();
					L.DomEvent.preventDefault(e);
					return;
				// Up
				case 38:
					this._select(-1);
					L.DomEvent.preventDefault(e);
					return;
				// Down
				case 40:
					this._select(1);
					L.DomEvent.preventDefault(e);
					return;
				}
			}
		},

		_complete: function(completeFn, trySelect, allowEmpty) {
			var v = this._elem.value,
				requestId = this._requestId = (this._requestId || 0) + 1;
			function completeResults(results) {
				if (requestId !== this._requestId || v !== this._elem.value) { return; }
				this._lastCompletedText = v;
				if (trySelect && results.length === 1) {
					this._resultSelected(results[0])();
				} else {
					this._setResults(results);
				}
			}

			if (!v && !allowEmpty) {
				return;
			}

			if (v !== this._lastCompletedText) {
				this._request = completeFn(v, completeResults, this);
			} else if (trySelect) {
				completeResults.call(this, this._results);
			}
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],49:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	var Itinerary = _dereq_('./itinerary');
	var Line = _dereq_('./line');
	var Plan = _dereq_('./plan');

	module.exports = Itinerary.extend({
		options: {
			fitSelectedRoutes: 'smart',
			routeLine: function(route, options) { return new Line(route, options); },
			autoRoute: true,
			routeWhileDragging: false,
			routeDragInterval: 500,
			waypointMode: 'connect',
			showAlternatives: false,
			defaultErrorHandler: function(e) {
				//console.error('Routing error:', e.error);
			}
		},

		initialize: function(options) {
			L.Util.setOptions(this, options);

			this._router = this.options.router;
			this._plan = this.options.plan || new Plan(this.options.waypoints, options);
			this._requestCount = 0;

			Itinerary.prototype.initialize.call(this, options);

			this.on('routeselected', this._routeSelected, this);
			if (this.options.defaultErrorHandler) {
				this.on('routingerror', this.options.defaultErrorHandler);
			}
			this._plan.on('waypointschanged', this._onWaypointsChanged, this);
			if (options.routeWhileDragging) {
				this._setupRouteDragging();
			}
		},

		_onZoomEnd: function() {
			if (!this._selectedRoute ||
				!this._router.requiresMoreDetail) {
				return;
			}

			var map = this._map;
			if (this._router.requiresMoreDetail(this._selectedRoute,
					map.getZoom(), map.getBounds())) {
				this.route({
					callback: L.bind(function(err, routes) {
						var i;
						if (!err) {
							for (i = 0; i < routes.length; i++) {
								this._routes[i].properties = routes[i].properties;
							}
							this._updateLineCallback(err, routes);
						}

					}, this),
					simplifyGeometry: false,
					geometryOnly: true
				});
			}
		},

		onAdd: function(map) {
			if (this.options.autoRoute) {
				this.route();
			}

                        var parent = L.DomUtil.get('routing-container');

			var container = Itinerary.prototype.onAdd.call(this, map);

			this._map = map;
			this._map.addLayer(this._plan);

			this._map.on('zoomend', this._onZoomEnd, this);

			if (this._plan.options.geocoder) {
				//container.childNodes[1].insertBefore(this._plan.createGeocoders(), container.childNodes[1].firstChild);
				container.insertBefore(this._plan.createGeocoders(), container.firstChild);
			}

			parent.insertBefore(container, parent.firstChild);

			return L.DomUtil.create('div','leaflet-control-hidden');
			//return container;
		},

		onRemove: function(map) {
			map.off('zoomend', this._onZoomEnd, this);
			if (this._line) {
				map.removeLayer(this._line);
			}
			map.removeLayer(this._plan);
			if (this._alternatives && this._alternatives.length > 0) {
				for (var i = 0, len = this._alternatives.length; i < len; i++) {
					map.removeLayer(this._alternatives[i]);
				}
			}
			return Itinerary.prototype.onRemove.call(this, map);
		},

		getWaypoints: function() {
			return this._plan.getWaypoints();
		},

		setWaypoints: function(waypoints) {
			this._plan.setWaypoints(waypoints);
			return this;
		},

		spliceWaypoints: function() {
			var removed = this._plan.spliceWaypoints.apply(this._plan, arguments);
			return removed;
		},

		spliceWaypointsDirect: function() {
			var prev = this._plan.options.straightLines;
			this._plan.options.straightLines = true;
			var removed = this._plan.spliceWaypoints.apply(this._plan, arguments);
			this._plan.options.straightLines = prev;
			return removed;
		},

		getPlan: function() {
			return this._plan;
		},

		getRouter: function() {
			return this._router;
		},

		_routeSelected: function(e) {

                        var route = this._selectedRoute = e.route;

                        if (this.options.waypointMode === 'snap') {
                                this._plan.off('waypointschanged', this._onWaypointsChanged, this);
                                this.setWaypoints(this._cloneWaypoints(e.route.actualWaypoints));
                                this._plan.on('waypointschanged', this._onWaypointsChanged, this);
                        }

			var alternatives = this.options.showAlternatives && e.alternatives,
				fitMode = this.options.fitSelectedRoutes,
				fitBounds =
					(fitMode === 'smart' && route.inputOptions.roundTrip && !this._waypointsVisible()) ||
					(fitMode !== 'smart' && fitMode);

			// for point-to-point, only snap to the route if no waypoints are visible, or there's 2 wps
			if (fitMode === 'smart' && !route.inputOptions.roundTrip) {
				fitBounds = !this._anyWaypointInViewport() || e.route.actualWaypoints.length == 2 || this._map.getZoom() <= 3;
			}

			this._updateLines({route: route, alternatives: alternatives});

			if (fitBounds) {
				try {
					this._map.fitBounds(this._line.getBounds(), { paddingTopLeft: L.point(0,170), paddingBottomRight: L.point(0,50) });
				} catch (err) {
				}
			}
		},

                _cloneWaypoints: function(inputWaypoints) {
                        var wps = [], i;
                        for (i = 0; i < inputWaypoints.length; i++) {
                            wps.push({
                                latLng: L.latLng(inputWaypoints[i].latLng.lat, inputWaypoints[i].latLng.lng),
                                name: inputWaypoints[i].name,
                                options: L.extend({}, inputWaypoints[i].options)
                            });
                        }
                        return wps;
                },

		_waypointsVisible: function() {
			var wps = this.getWaypoints(),
				mapSize,
				bounds,
				boundsSize,
				i,
				p;

			try {
				mapSize = this._map.getSize();

				for (i = 0; i < wps.length; i++) {
					p = this._map.latLngToLayerPoint(wps[i].latLng);

					if (bounds) {
						bounds.extend(p);
					} else {
						bounds = L.bounds([p]);
					}
				}

				boundsSize = bounds.getSize();
				return (boundsSize.x > mapSize.x / 5 ||
					boundsSize.y > mapSize.y / 5) && this._waypointsInViewport();

			} catch (e) {
				return false;
			}
		},

		_waypointsInViewport: function() {
			var wps = this.getWaypoints(),
				mapBounds,
				i;

			try {
				mapBounds = this._map.getBounds();
			} catch (e) {
				return false;
			}

			for (i = 0; i < wps.length; i++) {
				if (!mapBounds.contains(wps[i].latLng)) {
					return false;
				}
			}

			return true;
		},

                _anyWaypointInViewport: function() {
                        var wps = this.getWaypoints(),
                                mapBounds,
                                i;

                        try {
                                mapBounds = this._map.getBounds();
                        } catch (e) {
                                return false;
                        }

                        for (i = 0; i < wps.length; i++) {
                                if (mapBounds.contains(wps[i].latLng)) {
                                        return true;
                                }
                        }

                        return false;
                },

		_updateLines: function(routes) {
			var addWaypoints = this.options.addWaypoints !== undefined ?
				this.options.addWaypoints : true;
			this._clearLines();

			// add alternatives first so they lie below the main route
			this._alternatives = [];
			if (routes.alternatives) routes.alternatives.forEach(function(alt, i) {
				this._alternatives[i] = this.options.routeLine(alt,
					L.extend({
						isAlternative: true
					}, this.options.altLineOptions || this.options.lineOptions));
				this._alternatives[i].addTo(this._map);
				this._hookAltEvents(this._alternatives[i]);
			}, this);

			this._line = this.options.routeLine(routes.route,
				L.extend({
					addWaypoints: addWaypoints,
					extendToWaypoints: this.options.waypointMode === 'connect'
				}, this.options.lineOptions));
			this._line.addTo(this._map);
			this._hookEvents(this._line);
		},

		_hookEvents: function(l) {
			l.on('linetouched', function(e) {
				this._plan.dragNewWaypoint(e);
			}, this);
		},

		_hookAltEvents: function(l) {
			l.on('linetouched', function(e) {
				var alts = this._routes.slice();
				var selected = alts.splice(e.target._route.routesIndex, 1)[0];
				this.fire('routeselected', {route: selected, alternatives: alts});
			}, this);
		},

		_onWaypointsChanged: function(e) {
			if (this.options.autoRoute) {
				this.route({});
			}
			if (!this._plan.isReady()) {
				this._invalidateRoute();
			}
			this.fire('waypointschanged', {waypoints: e.waypoints});
		},

		_invalidateRoute: function() {
			this._selectedRoute = null;
			this._routes = [];
			this._clearLines();
			this._clearAlts();
			this.fire('routeinvalidated');
		},

		_setupRouteDragging: function() {
			var timer = 0,
				waypoints;

			this._plan.on('waypointdrag', L.bind(function(e) {
				waypoints = e.waypoints;
				if (!timer) {
					timer = setTimeout(L.bind(function() {
						this.route({
							waypoints: waypoints,
							geometryOnly: true,
							callback: L.bind(this._updateLineCallback, this)
						});
						timer = undefined;
					}, this), this.options.routeDragInterval);
				}
			}, this));
			this._plan.on('waypointdragend', function() {
				if (timer) {
					clearTimeout(timer);
					timer = undefined;
				}
				this.route();
			}, this);
		},

		_updateLineCallback: function(err, routes) {
			if (!err) {
				routes = routes.slice();
				var selected = routes.splice(this._selectedRoute.routesIndex, 1)[0];
				this._updateLines({
					route: selected,
					alternatives: this.options.showAlternatives ? routes : []
				});
			} else if (err.type !== 'abort') {
				this._clearLines();
			}
		},

		route: function(options) {
			var ts = ++this._requestCount,
				wps;

			if (this._pendingRequest && this._pendingRequest.abort) {
				this._pendingRequest.abort();
				this._pendingRequest = null;
			}

			options = options || {};
			options.greenPreference = this._plan.options.greenPreference;
			options.hillPreference = this._plan.options.hillPreference;
			options.avoidRepetition = this._plan.options.avoidRepetition;
			options.avoidUnlitStreets = this._plan.options.avoidUnlitStreets;
                        options.avoidUnsafeStreets = this._plan.options.avoidUnsafeStreets;
			options.roundTrip = this._plan.options.roundTrip;
			options.targetDistance = this._plan.options.targetDistance;

			if (this._plan.isReady()) {
				if (this.options.useZoomParameter) {
					options.z = this._map && this._map.getZoom();
				}

				wps = options && options.waypoints || this._plan.getWaypoints();

				this.fire('routingstart', {waypoints: wps});
				this._pendingRequest = this._router.route(wps, function(err, routes) {
					this._pendingRequest = null;

					if (options.callback) {
						return options.callback.call(this, err, routes);
					}

					// Prevent race among multiple requests,
					// by checking the current request's count
					// against the last request's; ignore result if
					// this isn't the last request.
					if (ts === this._requestCount) {
						if (err || !routes || !routes.length) {
							this._invalidateRoute();
							if (!err || err.type !== 'abort') {
								this.fire('routingerror', {error: err || {message: 'No route found'}});
							}
							return;
						}
						this._clearLines();
						this._clearAlts();

						routes.forEach(function(route, i) { route.routesIndex = i; });

						if (!options.geometryOnly) {
							this.fire('routesfound', {waypoints: wps, routes: routes});
							this.setAlternatives(routes);
						} else {
							var selectedRoute = routes.splice(0,1)[0];
							this._routeSelected({route: selectedRoute, alternatives: routes});
						}
					}
				}, this, options);
			}
		},

		_clearLines: function() {
			if (this._line) {
				this._map.removeLayer(this._line);
				delete this._line;
			}
			if (this._alternatives && this._alternatives.length) {
				for (var i in this._alternatives) {
					this._map.removeLayer(this._alternatives[i]);
				}
				this._alternatives = [];
			}
			this.fire('routecleared');
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./itinerary":55,"./line":56,"./plan":60}],50:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	module.exports = L.Control.extend({
		options: {
			header: 'Error: ',
			formatMessage: function(error) {
				if (error.response && error.response.error)
					error = error.response.error;
				if (error.code < 0) {
					return 'Calculating the route caused an error. Technical description follows: <code><pre>' +
						error.message + '</pre></code>';
				} else {
					return error.message;
				}
			}
		},

		initialize: function(routingControl, options) {
			L.Control.prototype.initialize.call(this, options);
			routingControl
				.on('routingerror', L.bind(function(e) {
					if (this._element) {
						this._element.children[1].innerHTML = this.options.formatMessage(e.error);
						this._element.style.visibility = 'visible';
					}
				}, this))
				.on('routingstart', L.bind(function() {
					if (this._element) {
						this._element.style.visibility = 'hidden';
					}
				}, this));
		},

		show: function() {
			var header,
				message;

			this._element = L.DomUtil.get('routing-error');
			this._element.style.visibility = 'hidden';

			header = L.DomUtil.create('strong', null, this._element);
			message = L.DomUtil.create('span', null, this._element);

			header.innerHTML = this.options.header;

			return this._element;
		},

		onRemove: function() {
			delete this._element;
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],51:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	var Localization = _dereq_('./localization');

	module.exports = L.Class.extend({
		options: {
			units: 'metric',
			unitNames: null,
			language: 'en',
			roundingSensitivity: 1,
			distanceTemplate: '{value} {unit}'
		},

		initialize: function(options) {
			L.setOptions(this, options);

			var langs = L.Util.isArray(this.options.language) ?
				this.options.language :
				[this.options.language, 'en'];
			this._localization = new Localization(langs);
		},

		formatDistance: function(d /* Number (meters) */, sensitivity) {
			var un = this.options.unitNames || this._localization.localize('units'),
				simpleRounding = sensitivity <= 0,
				round = simpleRounding ? function(v) { return v; } : L.bind(this._round, this),
			    v,
			    yards,
				data,
				pow10;

			if (this.options.units === 'imperial') {
				yards = d / 0.9144;
				if (yards >= 1000) {
					data = {
						value: round(d / 1609.344, sensitivity),
						unit: un.miles
					};
				} else {
					data = {
						value: round(yards, sensitivity),
						unit: un.yards
					};
				}
			} else {
				v = round(d, sensitivity);
				data = {
					value: v >= 1000 ? (v / 1000) : v,
					unit: v >= 1000 ? un.kilometers : un.meters
				};
			}

			if (simpleRounding) {
				data.value = data.value.toFixed(-sensitivity);
			}

			return L.Util.template(this.options.distanceTemplate, data);
		},

		_round: function(d, sensitivity) {
			var s = sensitivity || this.options.roundingSensitivity,
				pow10 = Math.pow(10, (Math.floor(d / s) + '').length - 1),
				r = Math.floor(d / pow10),
				p = (r > 5) ? pow10 : pow10 / 2;

			return Math.round(d / p) * p;
		},

		formatTime: function(t /* Number (seconds) */) {
			var un = this.options.unitNames || this._localization.localize('units');
			// More than 30 seconds precision looks ridiculous
			t = Math.round(t / 30) * 30;

			if (t > 86400) {
				return Math.round(t / 3600) + ' ' + un.hours;
			} else if (t > 3600) {
				return Math.floor(t / 3600) + ' ' + un.hours + ' ' +
					Math.round((t % 3600) / 60) + ' ' + un.minutes;
			} else if (t > 300) {
				return Math.round(t / 60) + ' ' + un.minutes;
			} else if (t > 60) {
				return Math.floor(t / 60) + ' ' + un.minutes +
					(t % 60 !== 0 ? ' ' + (t % 60) + ' ' + un.seconds : '');
			} else {
				return t + ' ' + un.seconds;
			}
		},

		formatInstruction: function(instr, i) {
			if (instr.text === undefined) {
				return this.capitalize(L.Util.template(this._getInstructionTemplate(instr, i),
					L.extend({}, instr, {
						exitStr: instr.exit ? this._localization.localize('formatOrder')(instr.exit) : '',
						dir: this._localization.localize(['directions', instr.direction]),
						modifier: this._localization.localize(['directions', instr.modifier])
					})));
			} else {
				return instr.text;
			}
		},

		getIconName: function(instr, i) {
			switch (instr.type) {
			case 'Head':
				if (i === 0) {
					return 'depart';
				}
				break;
			case 'WaypointReached':
				return 'via';
			case 'Roundabout':
				return 'enter-roundabout';
			case 'DestinationReached':
				return 'arrive';
			}

			switch (instr.modifier) {
			case 'Straight':
				return 'continue';
			case 'SlightRight':
				return 'bear-right';
			case 'Right':
				return 'turn-right';
			case 'SharpRight':
				return 'sharp-right';
			case 'TurnAround':
			case 'Uturn':
				return 'u-turn';
			case 'SharpLeft':
				return 'sharp-left';
			case 'Left':
				return 'turn-left';
			case 'SlightLeft':
				return 'bear-left';
			}
		},

		capitalize: function(s) {
			return s.charAt(0).toUpperCase() + s.substring(1);
		},

		_getInstructionTemplate: function(instr, i) {
			var type = instr.type === 'Straight' ? (i === 0 ? 'Head' : 'Continue') : instr.type,
				strings = this._localization.localize(['instructions', type]);

			if (!strings) {
				strings = [
					this._localization.localize(['directions', type]),
					' ' + this._localization.localize(['instructions', 'Onto'])
				];
			}

			return strings[0] + (strings.length > 1 && instr.road ? strings[1] : '');
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./localization":57}],52:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);
	var Autocomplete = _dereq_('./autocomplete');
	var Localization = _dereq_('./localization');

	function selectInputText(input) {
		if (input.setSelectionRange) {
			// On iOS, select() doesn't work
			input.setSelectionRange(0, 9999);
		} else {
			// On at least IE8, setSeleectionRange doesn't exist
			input.select();
		}
	}

	module.exports = L.Class.extend({
		includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

		options: {
			createGeocoder: function(i, nWps, options) {
				var container = L.DomUtil.create('div', 'leaflet-routing-geocoder'),
					input = L.DomUtil.create('input', '', container),
					remove = options.addWaypoints ? L.DomUtil.create('button', 'delete-waypoint', container) : undefined;
				if (remove) {
					remove.innerHTML = '<i class="fa fa-times" aria-hidden="true"></i>';
				}

				var updown = L.DomUtil.create('div', 'up-down-container', container);
				var up = L.DomUtil.create('button', 'up-down', updown);
				up.innerHTML = '<i class="fa fa-caret-up" aria-hidden="true"></i>';
				var down = L.DomUtil.create('button', 'up-down', updown);
				down.innerHTML = '<i class="fa fa-caret-down" aria-hidden="true"></i>';

				input.disabled = !options.addWaypoints;

				return {
					container: container,
					input: input,
					closeButton: remove,
					upButton: up,
					downButton: down
				};
			},
			geocoderPlaceholder: function(i, numberWaypoints, geocoderElement) {
				var l = new Localization(geocoderElement.options.language).localize('ui');
				return i === 0 ?
					l.startPlaceholder :
					(i < numberWaypoints - 1 ?
						L.Util.template(l.viaPlaceholder, {viaNumber: i}) :
						l.endPlaceholder);
			},

			geocoderClass: function() {
				return '';
			},

			waypointNameFallback: function(latLng) {
				var lat = (Math.round(latLng.lat * 10000) / 10000).toString(),
					lng = (Math.round(latLng.lng * 10000) / 10000).toString();
				return lat + ', '+ lng;
			},
			maxGeocoderTolerance: 200,
			autocompleteOptions: {},
			language: 'en',
		},

		initialize: function(wp, i, nWps, options) {
			L.setOptions(this, options);

			var g = this.options.createGeocoder(i, nWps, this.options),
				closeButton = g.closeButton,
				upButton = g.upButton,
				downButton = g.downButton,
				geocoderInput = g.input;
			geocoderInput.setAttribute('placeholder', this.options.geocoderPlaceholder(i, nWps, this));
			geocoderInput.className = this.options.geocoderClass(i, nWps);

			this._element = g;
			this._waypoint = wp;
			this._waypointIndex = i;

			this.update();
			// This has to be here, or geocoder's value will not be properly
			// initialized.
			// TODO: look into why and make _updateWaypointName fix this.
			geocoderInput.value = wp.name;

			L.DomEvent.addListener(geocoderInput, 'click', function() {
				selectInputText(this);
			}, geocoderInput);

			if (closeButton) {
				L.DomEvent.addListener(closeButton, 'click', function() {
					this.fire('delete', { waypoint: this._waypoint });
				}, this);
			}
			L.DomEvent.addListener(upButton, 'click', function() {
				this.fire('moveup', { waypoint: this._waypoint });
			}, this);
			L.DomEvent.addListener(downButton, 'click', function() {
				this.fire('movedown', { waypoint: this._waypoint });
			}, this);

			new Autocomplete(geocoderInput, function(r) {
					geocoderInput.value = r.name;
					wp.name = r.name;
					wp.latLng = r.center;
					this.fire('geocoded', { waypoint: wp, value: r });
				}, this, L.extend({
					resultFn: this.options.geocoder.geocode,
					resultContext: this.options.geocoder,
					autocompleteFn: this.options.geocoder.suggest,
					autocompleteContext: this.options.geocoder
				}, this.options.autocompleteOptions));
		},

		getContainer: function() {
			return this._element.container;
		},

		setValue: function(v) {
			this._element.input.value = v;
		},

		update: function(force) {
			var wp = this._waypoint,
				wpCoords;

			wp.name = wp.name || '';

			if (wp.latLng && (force || !wp.name)) {
				wpCoords = this.options.waypointNameFallback(wp.latLng);
				if (this._waypointIndex < 2 && this.options.geocoder && this.options.geocoder.reverse && wp.options && wp.options.visible) {
					// Route requests copy waypoints before names arrive. Keep request state
					// in their shared options so rebuilding the controls cannot bill twice.
					var key = wp.latLng.lat + ',' + wp.latLng.lng,
						state = wp.options.reverseGeocode,
						startRequest = !state || state.key !== key;
					if (startRequest) {
						state = wp.options.reverseGeocode = { key: key, callbacks: [], done: false };
					}
					var applyName = L.bind(function() {
						if (wp.latLng.lat + ',' + wp.latLng.lng !== key) { return; }
						wp.name = state.name;
						this._update();
					}, this);
					if (state.done) {
						applyName();
					} else {
						state.callbacks.push(applyName);
						if (startRequest) {
							var coordinate = L.latLng(wp.latLng.lat, wp.latLng.lng);
							this.options.geocoder.reverse(coordinate, 67108864 /* zoom 18 */, function(rs) {
								state.name = rs.length > 0 && rs[0].center.distanceTo(coordinate) < this.options.maxGeocoderTolerance ? rs[0].name : wpCoords;
								state.done = true;
								var callbacks = state.callbacks;
								state.callbacks = [];
								callbacks.forEach(function(cb) { cb(); });
							}, this);
						}
					}
				} else {
					wp.name = wpCoords;
					this._update();
				}
			}
		},

		focus: function() {
			var input = this._element.input;
			input.focus();
			selectInputText(input);
		},

		_update: function() {
			var wp = this._waypoint,
			    value = wp && wp.name ? wp.name : '';
			this.setValue(value);
			this.fire('reversegeocoded', {waypoint: wp, value: value});
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./autocomplete":48,"./localization":57}],53:[function(_dereq_,module,exports){
(function (global){
var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null),
    Control = _dereq_('./control'),
    Itinerary = _dereq_('./itinerary'),
    Line = _dereq_('./line'),
    Plan = _dereq_('./plan'),
    Waypoint = _dereq_('./waypoint'),
    Autocomplete = _dereq_('./autocomplete'),
    Formatter = _dereq_('./formatter'),
    GeocoderElement = _dereq_('./geocoder-element'),
    Localization = _dereq_('./localization'),
    ItineraryBuilder = _dereq_('./itinerary-builder'),
    ErrorControl = _dereq_('./error-control');
    Polyline = _dereq_('./polyline');

L.routing = {
    control: function(options) { return new Control(options); },
    itinerary: function(options) {
        return Itinerary(options);
    },
    line: function(route, options) {
        return new Line(route, options);
    },
    plan: function(waypoints, options) {
        return new Plan(waypoints, options);
    },
    waypoint: function(latLng, name, options) {
        return new Waypoint(latLng, name, options);
    },
    localization: function(options) {
        return new Localization(options);
    },
    formatter: function(options) {
        return new Formatter(options);
    },
    geocoderElement: function(wp, i, nWps, plan) {
        return new L.Routing.GeocoderElement(wp, i, nWps, plan);
    },
    itineraryBuilder: function(options) {
        return new ItineraryBuilder(options);
    },
    errorControl: function(routingControl, options) {
        return new ErrorControl(routingControl, options);
    },
    autocomplete: function(elem, callback, context, options) {
        return new Autocomplete(elem, callback, context, options);
    }
};

module.exports = L.Routing = {
    Control: Control,
    Itinerary: Itinerary,
    Line: Line,
    Plan: Plan,
    Waypoint: Waypoint,
    Autocomplete: Autocomplete,
    Formatter: Formatter,
    GeocoderElement: GeocoderElement,
    Localization: Localization,
    Formatter: Formatter,
    ItineraryBuilder: ItineraryBuilder,
    Polyline: Polyline,

    // Legacy; remove these in next major release
    control: L.routing.control,
    itinerary: L.routing.itinerary,
    line: L.routing.line,
    plan: L.routing.plan,
    waypoint: L.routing.waypoint,
    geocoderElement: L.routing.geocoderElement,
    mapbox: L.routing.mapbox,
    errorControl: L.routing.errorControl,
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./polyline":2,"./autocomplete":48,"./control":49,"./error-control":50,"./formatter":51,"./geocoder-element":52,"./itinerary":55,"./itinerary-builder":54,"./line":56,"./localization":57,"./plan":60,"./waypoint":61}],54:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	module.exports = L.Class.extend({
		options: {
			containerClassName: ''
		},

		initialize: function(options) {
			L.setOptions(this, options);
		},

		createContainer: function(className) {
			var table = L.DomUtil.create('table', (className || '') + ' ' + this.options.containerClassName),
				colgroup = L.DomUtil.create('colgroup', '', table);

			L.DomUtil.create('col', 'leaflet-routing-instruction-icon', colgroup);
			L.DomUtil.create('col', 'leaflet-routing-instruction-text', colgroup);
			L.DomUtil.create('col', 'leaflet-routing-instruction-distance', colgroup);

			return table;
		},

		createStepsContainer: function() {
			return L.DomUtil.create('tbody', '');
		},

		createStep: function(text, distance, icon, steps) {
			var row = L.DomUtil.create('tr', '', steps),
				span,
				td;
			td = L.DomUtil.create('td', '', row);
			span = L.DomUtil.create('span', 'leaflet-routing-icon leaflet-routing-icon-'+icon, td);
			td.appendChild(span);
			td = L.DomUtil.create('td', '', row);
			td.appendChild(document.createTextNode(text));
			td = L.DomUtil.create('td', '', row);
			td.appendChild(document.createTextNode(distance));
			return row;
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],55:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);
	var Formatter = _dereq_('./formatter');
	var ItineraryBuilder = _dereq_('./itinerary-builder');

	module.exports = L.Control.extend({
		includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

		options: {
			pointMarkerStyle: {
				radius: 5,
				color: '#03f',
				fillColor: 'white',
				opacity: 1,
				fillOpacity: 0.7
			},
			summaryTemplate: '<h2>{name}</h2><h3>{distance}, {time}</h3>',
			timeTemplate: '{time}',
			containerClassName: '',
			alternativeClassName: '',
			minimizedClassName: '',
			itineraryClassName: '',
			totalDistanceRoundingSensitivity: -1,
			show: true,
			collapsible: undefined,
			collapseBtn: undefined,
			collapseBtnClass: 'leaflet-routing-collapse-btn'
		},

		initialize: function(options) {
			L.setOptions(this, options);
			this._formatter = this.options.formatter || new Formatter(this.options);
			this._itineraryBuilder = this.options.itineraryBuilder || new ItineraryBuilder({
				containerClassName: this.options.itineraryClassName
			});
		},

		onAdd: function(map) {
			var container = L.DomUtil.create('div', 'leaflet-routing-container');

			this._container = container;
			this._altContainer = this.createAlternativesContainer();
			this._container.appendChild(this._altContainer);
			L.DomEvent.addListener(this._container, 'mousewheel', function(e) {
				L.DomEvent.stopPropagation(e);
			});

			return container;
		},

		onRemove: function() {
		},

		createAlternativesContainer: function() {
			return L.DomUtil.create('div', 'leaflet-routing-alternatives-container');
		},

		setAlternatives: function(routes) {
			var i,
			    alt,
			    altDiv;

			this._clearAlts();

			this._routes = routes;

			/*
			for (i = 0; i < this._routes.length; i++) {
				alt = this._routes[i];
				altDiv = this._createAlternative(alt, i);
				this._altContainer.appendChild(altDiv);
				this._altElements.push(altDiv);
			}

			if (this._routes.length > 1) {
				this._altContainer.style.display = 'block';
			} else {
				this._altContainer.style.display = 'none';
			}
			*/
			this._altContainer.style.display = 'none';

			this._selectRoute({route: this._routes[0], alternatives: this._routes.slice(1)});

			return this;
		},

		show: function() {
			this._container.style.display = 'block';
		},

		hide: function() {
			this._container.style.display = 'none';
		},

		_toggle: function() {
			var collapsed = this._container.style.display == 'none';
			this[collapsed ? 'show' : 'hide']();
		},

		_createAlternative: function(alt, i) {
			var altDiv = L.DomUtil.create('div', 'leaflet-routing-alt ' +
				this.options.alternativeClassName +
				(i > 0 ? ' leaflet-routing-alt-minimized ' + this.options.minimizedClassName : '')),
				template = this.options.summaryTemplate,
				data = L.extend({
					name: alt.name,
					distance: this._formatter.formatDistance(alt.summary.totalDistance, this.options.totalDistanceRoundingSensitivity),
					time: this._formatter.formatTime(alt.summary.totalTime)
				}, alt);
			altDiv.innerHTML = typeof(template) === 'function' ? template(data) : L.Util.template(template, data);
			L.DomEvent.addListener(altDiv, 'click', this._onAltClicked, this);
			this.on('routeselected', this._selectAlt, this);

			altDiv.appendChild(this._createItineraryContainer(alt));
			return altDiv;
		},

		_clearAlts: function() {
			var el = this._altContainer;
			while (el && el.firstChild) {
				el.removeChild(el.firstChild);
			}

			this._altElements = [];
		},

		_createItineraryContainer: function(r) {
			var container = this._itineraryBuilder.createContainer(),
			    steps = this._itineraryBuilder.createStepsContainer(),
			    i,
			    instr,
			    step,
			    distance,
			    text,
			    icon;

			container.appendChild(steps);

			for (i = 0; i < r.instructions.length; i++) {
				instr = r.instructions[i];
				text = this._formatter.formatInstruction(instr, i);
				distance = this._formatter.formatDistance(instr.distance);
				icon = this._formatter.getIconName(instr, i);
				step = this._itineraryBuilder.createStep(text, distance, icon, steps);

				if(instr.index) {
					this._addRowListeners(step, r.coordinates[instr.index]);
				}
			}

			return container;
		},

		_addRowListeners: function(row, coordinate) {
			L.DomEvent.addListener(row, 'mouseover', function() {
				this._marker = L.circleMarker(coordinate,
					this.options.pointMarkerStyle).addTo(this._map);
			}, this);
			L.DomEvent.addListener(row, 'mouseout', function() {
				if (this._marker) {
					this._map.removeLayer(this._marker);
					delete this._marker;
				}
			}, this);
			L.DomEvent.addListener(row, 'click', function(e) {
				this._map.panTo(coordinate);
				L.DomEvent.stopPropagation(e);
			}, this);
		},

		_onAltClicked: function(e) {
			var altElem = e.target || window.event.srcElement;
			while (!L.DomUtil.hasClass(altElem, 'leaflet-routing-alt')) {
				altElem = altElem.parentElement;
			}

			var j = this._altElements.indexOf(altElem);
			var alts = this._routes.slice();
			var route = alts.splice(j, 1)[0];

			this.fire('routeselected', {
				route: route,
				alternatives: alts
			});
		},

		_selectAlt: function(e) {
			var altElem,
			    j,
			    n,
			    classFn;

			altElem = this._altElements[e.route.routesIndex];

			if (L.DomUtil.hasClass(altElem, 'leaflet-routing-alt-minimized')) {
				for (j = 0; j < this._altElements.length; j++) {
					n = this._altElements[j];
					classFn = j === e.route.routesIndex ? 'removeClass' : 'addClass';
					L.DomUtil[classFn](n, 'leaflet-routing-alt-minimized');
					if (this.options.minimizedClassName) {
						L.DomUtil[classFn](n, this.options.minimizedClassName);
					}

					if (j !== e.route.routesIndex) n.scrollTop = 0;
				}
			}

			L.DomEvent.stop(e);
		},

		_selectRoute: function(routes) {
			if (this._marker) {
				this._map.removeLayer(this._marker);
				delete this._marker;
			}
			this.fire('routeselected', routes);
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./formatter":51,"./itinerary-builder":54}],56:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	module.exports = L.LayerGroup.extend({
		includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

		options: {
			styles: [
				{color: 'black', opacity: 0.15, weight: 9},
				{color: 'white', opacity: 0.8, weight: 6},
				{color: 'red', opacity: 1, weight: 2}
			],
			missingRouteStyles: [
				{color: 'black', opacity: 0.15, weight: 7},
				{color: 'white', opacity: 0.6, weight: 4},
				{color: 'gray', opacity: 0.8, weight: 2, dashArray: '7,12'}
			],
			addWaypoints: true,
			extendToWaypoints: true,
			missingRouteTolerance: 10
		},

		initialize: function(route, options) {
			L.setOptions(this, options);
			L.LayerGroup.prototype.initialize.call(this, options);
			this._route = route;

			if (this.options.extendToWaypoints) {
				this._extendToWaypoints();
			}

			this._addSegment(
				route.coordinates,
				this.options.styles,
				this.options.addWaypoints);
		},

		getBounds: function() {
			return L.latLngBounds(this._route.coordinates);
		},

		_findWaypointIndices: function() {
			var wps = this._route.inputWaypoints,
			    indices = [],
			    i;
			for (i = 0; i < wps.length; i++) {
				indices.push(this._findClosestRoutePoint(wps[i].latLng));
			}

			return indices;
		},

		_findClosestRoutePoint: function(latlng) {
			var minDist = Number.MAX_VALUE,
				minIndex,
			    i,
			    d;

			for (i = this._route.coordinates.length - 1; i >= 0 ; i--) {
				// TODO: maybe do this in pixel space instead?
				d = latlng.distanceTo(this._route.coordinates[i]);
				if (d < minDist) {
					minIndex = i;
					minDist = d;
				}
			}

			return minIndex;
		},

		_extendToWaypoints: function() {
			var wps = this._route.inputWaypoints,
				wpIndices = this._getWaypointIndices(),
			    i,
			    wpLatLng,
			    routeCoord;

			for (i = 0; i < wps.length; i++) {
				wpLatLng = wps[i].latLng;
				routeCoord = L.latLng(this._route.coordinates[wpIndices[i]]);
				if (wpLatLng.distanceTo(routeCoord) >
					this.options.missingRouteTolerance) {
					this._addSegment([wpLatLng, routeCoord],
						this.options.missingRouteStyles);
				}
			}
		},

		_addSegment: function(coords, styles, mouselistener) {
			var i,
				pl;

			for (i = 0; i < styles.length; i++) {
				pl = L.polyline(coords, styles[i]);
				if (i == styles.length - 1) {
					pl.setText('►  ', { center:true, offset: 6, attributes: {fill: 'red', 'font-size': 20}});
				}
				this.addLayer(pl);
				if (mouselistener) {
					pl.on('mousedown', this._onLineTouched, this);
				}
			}
		},

		_findNearestWpBefore: function(i) {
			var wpIndices = this._getWaypointIndices(),
				j = wpIndices.length - 1;
			while (j >= 0 && wpIndices[j] > i) {
				j--;
			}

			return j;
		},

		_onLineTouched: function(e) {
			var afterIndex = this._findNearestWpBefore(this._findClosestRoutePoint(e.latlng));
			this.fire('linetouched', {
				afterIndex: afterIndex,
				latlng: e.latlng
			});
			L.DomEvent.stop(e);
		},

		_getWaypointIndices: function() {
			if (!this._wpIndices) {
				this._wpIndices = this._route.waypointIndices || this._findWaypointIndices();
			}

			return this._wpIndices;
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],57:[function(_dereq_,module,exports){
/* 
   NOTICE
   Since version 3.2.5, the functionality in this file is by
   default NOT used for localizing OSRM instructions.
   Instead, we rely on the module osrm-text-instructions (https://github.com/Project-OSRM/osrm-text-instructions/).
   
   This file can still be used for other routing backends, or if you specify the
   stepToText option in the OSRMv1 class.
*/

(function() {
	'use strict';

	L.Routing = L.Routing || {};

	var Localization = L.Class.extend({
		initialize: function(langs) {
			this._langs = L.Util.isArray(langs) ? langs.slice() : [langs, 'en'];

			for (var i = 0, l = this._langs.length; i < l; i++) {
				var generalizedCode = /([A-Za-z]+)/.exec(this._langs[i])[1]
				if (!Localization[this._langs[i]]) {
					if (Localization[generalizedCode]) {
						this._langs[i] = generalizedCode;
					} else {
						throw new Error('No localization for language "' + this._langs[i] + '".');
					}
				}
			}
		},

		localize: function(keys) {
			var dict,
				key,
				value;

			keys = L.Util.isArray(keys) ? keys : [keys];

			for (var i = 0, l = this._langs.length; i < l; i++) {
				dict = Localization[this._langs[i]];
				for (var j = 0, nKeys = keys.length; dict && j < nKeys; j++) {
					key = keys[j];
					value = dict[key];
					dict = value;
				}

				if (value) {
					return value;
				}
			}
		}
	});

	module.exports = L.extend(Localization, {
		'en': {
			directions: {
				N: 'north',
				NE: 'northeast',
				E: 'east',
				SE: 'southeast',
				S: 'south',
				SW: 'southwest',
				W: 'west',
				NW: 'northwest',
				SlightRight: 'slight right',
				Right: 'right',
				SharpRight: 'sharp right',
				SlightLeft: 'slight left',
				Left: 'left',
				SharpLeft: 'sharp left',
				Uturn: 'Turn around'
			},
			instructions: {
				// instruction, postfix if the road is named
				'Head':
					['Head {dir}', ' on {road}'],
				'Continue':
					['Continue {dir}'],
				'TurnAround':
					['Turn around'],
				'WaypointReached':
					['Waypoint reached'],
				'Roundabout':
					['Take the {exitStr} exit in the roundabout', ' onto {road}'],
				'DestinationReached':
					['Destination reached'],
				'Fork': ['At the fork, turn {modifier}', ' onto {road}'],
				'Merge': ['Merge {modifier}', ' onto {road}'],
				'OnRamp': ['Turn {modifier} on the ramp', ' onto {road}'],
				'OffRamp': ['Take the ramp on the {modifier}', ' onto {road}'],
				'EndOfRoad': ['Turn {modifier} at the end of the road', ' onto {road}'],
				'Onto': 'onto {road}'
			},
			formatOrder: function(n) {
				var i = n % 10 - 1,
				suffix = ['st', 'nd', 'rd'];

				return suffix[i] ? n + suffix[i] : n + 'th';
			},
			ui: {
				startPlaceholder: L.Browser.mobile ? L.localisation.get('search.startLocationPlaceholderMobile') : L.localisation.get('search.startLocationPlaceholderDesktop'),
				viaPlaceholder: 'Via {viaNumber}',
				endPlaceholder: L.localisation.get('search.endLocationPlaceholder')
			},
			units: {
				meters: 'm',
				kilometers: 'km',
				yards: 'yd',
				miles: 'mi',
				hours: 'h',
				minutes: 'min',
				seconds: 's'
			}
		}
	});
})();

},{}],60:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);
	var GeocoderElement = _dereq_('./geocoder-element');
	var Waypoint = _dereq_('./waypoint');

	module.exports = (L.Layer || L.Class).extend({
		includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

		options: {
			dragStyles: [
				{color: 'black', opacity: 0.15, weight: 9},
				{color: 'white', opacity: 0.8, weight: 6},
				{color: 'red', opacity: 1, weight: 2, dashArray: '7,12'}
			],
			draggableWaypoints: true,
			routeWhileDragging: false,
			addWaypoints: true,
			reverseWaypoints: false,
			addButtonClassName: '',
			language: 'en',
			createGeocoderElement: function(wp, i, nWps, plan) {
				return new GeocoderElement(wp, i, nWps, plan);
			},
			createMarker: function(i, wp) {
				var options = {
						draggable: this.draggableWaypoints
					},
				    marker = L.marker(wp.latLng, options);

				return marker;
			},
			geocodersClassName: ''
		},

		initialize: function(waypoints, options) {
			L.Util.setOptions(this, options);
			this._waypoints = [];
			this.setWaypoints(waypoints);
		},

		isReady: function() {
			var i;
			for (i = 0; i < this._waypoints.length; i++) {
				if (!this._waypoints[i].latLng) {
					return false;
				}
			}

			return true;
		},

		switchToP2P: function() {
			L.DomUtil.get('switch-to-p2p').style.display = 'none';
			this.setRoundTrip(false);
			this.setTargetDistance(0);
			if (control._selectedRoute &&
			    typeof control._selectedRoute.overriddenParameters.avoidRepetition != 'undefined') {
				this.setAvoidRepetition(control._selectedRoute.overriddenParameters.avoidRepetition);
			}
			this.updateSettingsUI();
		},

		updateRouteSwitchVisibility: function() {
			var element = L.DomUtil.get('switch-to-p2p');
			if (element) element.style.display = this.getTargetDistance() > 0 ? 'block' : 'none';
		},

		updateGreenPreferenceUI: function() {
			var val = L.DomUtil.get('green_preference').value;
			L.DomUtil.get('green_label').innerHTML = val > 0 ? (val*100)+'%' : L.localisation.get('settings.preferGreenAreasDisabled');
		},

		updateHillsPreferenceUI: function() {
			var val = L.DomUtil.get('hill_preference').value,
			    lbl = L.DomUtil.get('hill_label');
			if (val == 0) {
				lbl.innerHTML = L.localisation.get('settings.hillsPreferenceNone');
			} else if (val > 0) {
				lbl.innerHTML = L.localisation.get('settings.hillsPreferencePositive') + ', '+(val*100)+'%';
			} else if (val < 0) {
				lbl.innerHTML = L.localisation.get('settings.hillsPreferenceNegative') + ', '+(Math.abs(val)*100)+'%';
			}
		},

		updateSettingsUI: function() {
			// Hash changes must still apply the route when the sidebar is detached.
			// Wait for a complete form so that rendering never leaves it half updated.
			var ids = ['inputRoundTrip', 'inputPointToPoint', 'inputDistance',
				'inputCustomDistance', 'inputCustomDistanceUnits', 'addWpBtn',
				'distance', 'custom-distance', 'green_preference', 'green_label',
				'avoid_unlit_streets', 'avoid_unsafe_streets', 'hill_preference',
				'hill_label', 'avoid_repetition', 'straight_lines', 'prevent_click_edits',
				'imperial_units', 'hiking_layer', 'fkt_layer', 'switch-to-p2p'];
			var missing = ids.filter(function(id) { return !L.DomUtil.get(id); });
			var distance = L.DomUtil.get('inputDistance');
			if (distance && distance.options.length < 2) missing.push('inputDistance.options');
			if (missing.length) {
				if (!this._missingSettingsUI && window.TrailRouterDiagnostics) {
					window.TrailRouterDiagnostics.report(new Error('Settings controls unavailable'), {
						operation: 'settings.render', missingControls: missing.join(',')
					});
				}
				this._missingSettingsUI = true;
				if (!this._settingsUIObserver && window.MutationObserver) {
					this._settingsUIObserver = new window.MutationObserver(L.bind(function() {
						// Read current options, including any subsequent hash changes.
						if (this._settingsUIObserver) this.updateSettingsUI();
					}, this));
					this._settingsUIObserver.observe(document.documentElement, {
						childList: true, subtree: true, attributes: true, attributeFilter: ['id']
					});
				}
				return;
			}
			if (this._settingsUIObserver) {
				this._settingsUIObserver.disconnect();
				delete this._settingsUIObserver;
			}
			delete this._missingSettingsUI;

			var inputRoundTrip = L.DomUtil.get('inputRoundTrip'),
			    inputPointToPoint = L.DomUtil.get('inputPointToPoint'),
			    inputDistance = L.DomUtil.get('inputDistance'),
			    inputCustomDistance = L.DomUtil.get('inputCustomDistance');

			// Rebuild unit choices before selecting the current distance and disabling
			// direct routing; rebuilding replaces the options and their selection.
			var currentlyImperial = inputDistance.options[1].innerHTML.match(/ile/) != null;
			if (this.options.imperialUnits != currentlyImperial) {
				this._setDistanceOptions(inputDistance);
			}
			inputDistance.value = this.options.targetDistance;
			L.DomUtil.get('inputCustomDistanceUnits').value = this.getImperialUnits() ? 'mi' : 'km';

			// RoundTrip vs P2P
			inputRoundTrip.checked = this.options.roundTrip;
			inputPointToPoint.checked = !this.options.roundTrip;
			if (this.options.roundTrip) {
				inputDistance.options[0].disabled = true;
				L.DomUtil.get('addWpBtn').style.display = 'none';
			} else {
				inputDistance.options[0].disabled = false;
				L.DomUtil.get('addWpBtn').style.display = 'block';
			}

			// Set the custom distance field
			var dist = this.options.imperialUnits ?
                                   this.options.targetDistance / 1609 : this.options.targetDistance / 1000;
			inputCustomDistance.value = dist >= 1 ? (dist == Math.floor(dist) ? Math.floor(dist) : dist.toFixed(1)) : "";

			// Display the custom distance if one of our fixed list is not already selected
			if (inputDistance.selectedIndex < 0 || inputDistance.value != this.options.targetDistance) {
				L.DomUtil.get('distance').style.display = 'none';
				L.DomUtil.get('custom-distance').style.display = 'block';
			}

			// Disable green areas if avoid unlit is ticked
			L.DomUtil.get('green_preference').disabled = this.options.avoidUnlitStreets

			// Settings tab
			L.DomUtil.get('green_preference').value = this.options.greenPreference;
			L.DomUtil.get('avoid_unlit_streets').checked = this.options.avoidUnlitStreets;
                        L.DomUtil.get('avoid_unsafe_streets').checked = this.options.avoidUnsafeStreets;
			L.DomUtil.get('hill_preference').value = this.options.hillPreference;
			L.DomUtil.get('avoid_repetition').checked = this.options.avoidRepetition;
			L.DomUtil.get('straight_lines').checked = this.options.straightLines;
			L.DomUtil.get('prevent_click_edits').checked = this.options.preventClickEdits;
			L.DomUtil.get('imperial_units').checked = this.options.imperialUnits;
                        L.DomUtil.get('hiking_layer').checked = this.options.hikingLayer;
			//L.DomUtil.get('strava_layer').checked = this.options.stravaLayer;
                        L.DomUtil.get('fkt_layer').checked = this.options.fktLayer;
			this.updateHillsPreferenceUI();
			this.updateGreenPreferenceUI();
			this.updateRouteSwitchVisibility();
		},

                getRoundTrip: function() { return this.options.roundTrip; },
                setRoundTrip: function(value) {
			this.options.roundTrip = value;
			if (this.options.roundTrip && this.options.targetDistance == 0) {
				this.options.targetDistance = 5000;
			} else if (!this.options.roundTrip && this.options.targetDistance > 0) {
				this.options.targetDistance = 0;
			}
		},
                getTargetDistance: function() { return this.options.targetDistance; },
                setTargetDistance: function(value) { this.options.targetDistance = value; },
                getGreenPreference: function() { return this.options.greenPreference; },
                setGreenPreference: function(value) { this.options.greenPreference = value; },
                getHillPreference: function() { return this.options.hillPreference; },
                setHillPreference: function(value) { this.options.hillPreference = value; },
                getAvoidRepetition: function() { return this.options.avoidRepetition; },
                setAvoidRepetition: function(value) { this.options.avoidRepetition = value; },
                getAvoidUnsafeStreets: function() { return this.options.avoidUnsafeStreets; },
                setAvoidUnsafeStreets: function(value) { this.options.avoidUnsafeStreets = value; },
                getAvoidUnlitStreets: function() { return this.options.avoidUnlitStreets; },
                setAvoidUnlitStreets: function(value) { this.options.avoidUnlitStreets = value; },
                getPreventClickEdits: function() { return this.options.preventClickEdits; },
                setPreventClickEdits: function(value) { this.options.preventClickEdits = value; },
                getStraightLines: function() { return this.options.straightLines; },
                setStraightLines: function(value) { this.options.straightLines = value; },
                getImperialUnits: function() { return this.options.imperialUnits; },
                setImperialUnits: function(value) { this.options.imperialUnits = value; },
                getHikingLayer: function() { return this.options.hikingLayer; },
                setHikingLayer: function(value) { this.options.hikingLayer = value; },
                getStravaLayer: function() { return this.options.stravaLayer; },
                setStravaLayer: function(value) { this.options.stravaLayer = value; },
                getFKTLayer: function() { return this.options.fktLayer; },
                setFKTLayer: function(value) { this.options.fktLayer = value; },
                getBaseLayer: function() { return this.options.baseLayer; },
                setBaseLayer: function(value) { this.options.baseLayer = value; },

		getWaypoints: function() {
			var i,
				wps = [];

			for (i = 0; i < this._waypoints.length; i++) {
				wps.push(this._waypoints[i]);
			}

			return wps;
		},

		getNonEmptyWaypoints: function() {
			var wps = [];
			for(var i=0; i<this._waypoints.length; i++) {
				if (this._waypoints[i].latLng)
					wps.push(this._waypoints[i]);
			}
			return wps;
		},

		setWaypoints: function(waypoints) {
			var args = [0, this._waypoints.length].concat(waypoints);
			this.spliceWaypoints.apply(this, args);
			return this;
		},

		spliceWaypoints: function() {
			var args = [arguments[0], arguments[1]],
			    i;

			// Normalize against the current plan before inspecting a waypoint.
			args[0] = Math.max(0, Math.min(this._waypoints.length, Math.floor(Number(args[0]) || 0)));
			args[1] = Math.max(0, Math.min(this._waypoints.length - args[0], Math.floor(Number(args[1]) || 0)));

			// Should this segment be drawn as a straight line?
			var wpOpts = { straightLines: this.options.straightLines ? true : false };

			// This creates our args[] call, with
			// args[0] indicating the start position for the splicing
			// args[1] indicating the number of elements to delete
			// args[2..n] indicating the new waypoints to add from start
			for (i = 2; i < arguments.length; i++) {
				args.push(arguments[i] && arguments[i].hasOwnProperty('latLng') ? arguments[i] : new Waypoint(arguments[i], null, wpOpts));
			}

			// If there any blank waypoints in the route plan, then
			// this code will overwrite the blanks with the newly
			// created waypoint. It does this by working backwards from
			// the end of the route plan, looking for the first empty
			// space and then inserting our waypoint at that space
			// Note that inserting means decreasing the start position
			// and increasing the delete count (to overwrite the blank)
			for (i = this._waypoints.length - 1; i >= 0 && args.length > 2; i--) {
				if (this._waypoints[i].latLng == null) {
					args[0]--;
					args[1]++;
				}
			}

			// Sometimes the above can yield args[0] = -1, which we don't want
			if (args[0] < 0) args[0] = 0;

			// In round-trip and P2P target-distance mode, additional waypoints are
			// created automatically by the backend, at points along the polygon/trail.
			// These waypoints are hidden in the UI input field list though. So if we
			// delete the visible ones, we do NOT expect the hidden ones to suddenly
			// appear. We expect the field to appear empty. The code below will delete
			// any hidden waypoints that are adjacent to a visibile one that's being
			// deleted.
			if (args[1] > 0 && this._waypoints[ args[0] ] && this._waypoints[ args[0] ].options.visible) {

				var start = args[0];
				var count = args[1];
				// Work backwards, marking additional WPs for removal if not visible
				for (i = start - 1; i > 0; i--) {
					if (this._waypoints[i].options.visible)
						break;
					args[0]--;
					args[1]++;
				}
				// Now the same, but work forwards. Start at original requested position
				for (i = start + count; i < this._waypoints.length; i++) {
					if (this._waypoints[i].options.visible)
						break;
					args[1]++;
				}
			}

			// The main bit of work
			[].splice.apply(this._waypoints, args);

			// Lastly, make sure we always have at least 2 waypoints in the UI
			// for direct, or 1 waypoint for round-trip
			var minWaypoints = this.getRoundTrip() ? 1 : 2;
			if (this._waypoints.length < minWaypoints) {
				args = [ this._waypoints.length, 0 ];
				for (i = minWaypoints - this._waypoints.length; i > 0; i--) {
					args.push(new Waypoint(null));
				}
				[].splice.apply(this._waypoints, args);
			}

			// Set which waypoints should be reverse geocoded.
			// We only reverse geocode point 0 if in RT mode, and points 0 and n-1 in P2P mode.
			// Note that any points added manually one at a time will all be geocoded.
			/*
			if (this.getRoundTrip()) {
				this._waypoints[0].options.reverseGeocode = true;
			} else {
				this._waypoints[0].options.reverseGeocode = true;
				this._waypoints[this._waypoints.length-1].options.reverseGeocode = true;
			}
			*/


			// Make sure there's always at least two waypoints
			//while (this._waypoints.length < 2) {
			//	this.spliceWaypoints(this._waypoints.length, 0, null);
			//}

			this._updateMarkers();
			this._fireChanged.apply(this, args);
		},

		onAdd: function(map) {
			this._map = map;
			this._updateMarkers();
		},

		onRemove: function() {
			var i;
			if (this._settingsUIObserver) {
				this._settingsUIObserver.disconnect();
				delete this._settingsUIObserver;
			}
			delete this._missingSettingsUI;
			this._removeMarkers();

			if (this._newWp) {
				for (i = 0; i < this._newWp.lines.length; i++) {
					this._map.removeLayer(this._newWp.lines[i]);
				}
			}

			delete this._map;
		},

		createGeocoders: function() {
			var container = L.DomUtil.create('div', 'leaflet-routing-geocoders ' + this.options.geocodersClassName),
				waypoints = this._waypoints,
			    addWpBtn,
			    resetBtn,
			    reverseBtn;

			//this._geocoderContainer = container;
			this._geocoderElems = [];


			if (this.options.addWaypoints) {
				resetBtn = L.DomUtil.create('button', 'leaflet-routing-reset ', container);
				resetBtn.setAttribute('type', 'button');
				resetBtn.id = 'resetBtn';
			        resetBtn.title = 'Reset';
				resetBtn.innerHTML = '<i class="fa fa-trash-o"></i>';

				L.DomEvent.addListener(resetBtn, 'click', function() {
					this.setWaypoints([]);
					this.updateSettingsUI();
				}, this);
			}

                        if (this.options.showRoundTrip) {
                                var container2 = L.DomUtil.create('div', 'leaflet-routing-geocoder', container);
                                container2.setAttribute('style','width:80%');

                                var divRT = L.DomUtil.create('label', '', container2);
                                var radioRT = L.DomUtil.create('input', 'with-gap', divRT);
                                radioRT.name = "routingMode";
                                radioRT.id = 'inputRoundTrip';
                                radioRT.setAttribute('type','radio');
                                var labelRT = L.DomUtil.create('span', '', divRT);
                                labelRT.setAttribute('for','inputRoundTrip');
                                labelRT.setAttribute('style','margin-right: 10px');
                                labelRT.innerHTML = L.localisation.get('search.roundTrip');

				var divP2P = L.DomUtil.create('label', '', container2);
                                var radioP2P = L.DomUtil.create('input', 'with-gap', divP2P);
                                radioP2P.name = "routingMode";
                                radioP2P.id = 'inputPointToPoint';
                                radioP2P.setAttribute('type','radio');
                                var labelP2P = L.DomUtil.create('span', '', divP2P);
                                labelP2P.setAttribute('for','inputPointToPoint');
                                labelP2P.innerHTML = L.localisation.get('search.pointToPoint');

                                radioP2P.checked = !this.options.roundTrip;
				radioRT.checked = this.options.roundTrip;
				var onchange = function() {
					this.setRoundTrip(radioRT.checked);
                                        L.DomUtil.get('distance').style.display = 'block';
                                        L.DomUtil.get('custom-distance').style.display = 'none';
					this.updateSettingsUI();
					this.spliceWaypoints(1, this._waypoints.length - 1);
				};

                                L.DomEvent.addListener(radioP2P, 'change', onchange, this);
                                L.DomEvent.addListener(radioRT, 'change', onchange, this);
                        }

			// This is where the geocoders actually sit inside
			this._geocoderContainer = L.DomUtil.create('div', 'geocoders', container);

			if (this.options.reverseWaypoints) {
				reverseBtn = L.DomUtil.create('button', 'leaflet-routing-reverse-waypoints', container);
				reverseBtn.setAttribute('type', 'button');
				L.DomEvent.addListener(reverseBtn, 'click', function() {
					this._waypoints.reverse();
					this.setWaypoints(this._waypoints);
				}, this);
			}

                        if (this.options.addWaypoints) {
                                addWpBtn = L.DomUtil.create('button', 'leaflet-routing-add-waypoint ' + this.options.addButtonClassName, container);
                                addWpBtn.setAttribute('type', 'button');
                                addWpBtn.id = 'addWpBtn';
                                L.DomEvent.addListener(addWpBtn, 'click', function() {
                                        this.spliceWaypoints(waypoints.length, 0, null);
					this._geocoderContainer.scrollTop = this._geocoderContainer.scrollHeight;
                                }, this);
                        }

			if (this.options.showTargetDistance) {
				var container2 = L.DomUtil.create('div', 'leaflet-routing-geocoder', container);
				container2.id = 'distance';
				var inputDistance = L.DomUtil.create('select', '', container2);
				inputDistance.id = 'inputDistance';
				this._setDistanceOptions(inputDistance);

                                var container3 = L.DomUtil.create('div', 'leaflet-routing-geocoder', container);
				container3.id = 'custom-distance';
                                var inputCustomDistance = L.DomUtil.create('input', '', container3);
                                inputCustomDistance.id = 'inputCustomDistance';
                                inputCustomDistance.setAttribute('type','number');
                                inputCustomDistance.setAttribute('min','1');
                                inputCustomDistance.setAttribute('max','200');
                                inputCustomDistance.setAttribute('step','0.1');
                                inputCustomDistance.setAttribute('placeholder','Distance');

                                var inputCustomDistanceUnits = L.DomUtil.create('input', '', container3);
                                inputCustomDistanceUnits.id = 'inputCustomDistanceUnits';
                                inputCustomDistanceUnits.setAttribute('readonly','1');
                                inputCustomDistanceUnits.value = this.getImperialUnits() ? 'mi' : 'km';

                                var goButton = L.DomUtil.create('a', 'btn btn-small', container3);
                                goButton.innerHTML = 'Go';
                                goButton.id = 'btnCustomDistance';
                                L.DomEvent.addListener(goButton, 'click', function() {
                                        var mult = this.getImperialUnits() ? 1609 : 1000;
                                        var dist = inputCustomDistance.value;
                                        var newp = this.getNonEmptyWaypoints();
                                        if (this.getRoundTrip() && (dist < 1 || isNaN(dist) || dist > 100)) {
                                            alert('Enter a distance between 1 and 100');
                                        } else if (!this.getRoundTrip() && (dist < 0 || dist > 100)) {
                                            alert('Enter a distance between 1 and 100, or an empty distance for direct routing');
                                        } else if (this.getRoundTrip() && newp.length < 1) {
                                            alert('You must enter a location');
                                        } else if (!this.getRoundTrip() && newp.length < 2) {
                                            alert('Enter at least two locations for point-to-point routing');
                                        } else {
                                            this.setTargetDistance(parseInt(inputCustomDistance.value * mult));
                                            this.updateSettingsUI();
                                            this._fireChanged();
                                        }
                                }, this);

				L.DomEvent.addListener(inputDistance, 'change', function() {
					if (inputDistance.value == "custom") {
						L.DomUtil.get('distance').style.display = 'none';
						L.DomUtil.get('custom-distance').style.display = 'block';
					} else {
						this.setTargetDistance(inputDistance.value);
						this.updateSettingsUI();
						this._fireChanged();
					}
				}, this);
			}

			this._updateGeocoders();
			this.on('waypointsspliced', this._updateGeocoders);

			return container;
		},

		_setDistanceOptions: function(inputDistance) {
			var existingIndex = inputDistance.selectedIndex;
			inputDistance.options.length = 0;
			if (this.getImperialUnits()) {
				var mileRoute = L.localisation.get('search.mileRoute');
				inputDistance.options.add( new Option(L.localisation.get('search.targetDistanceDirect'),0,true,true) );
                                inputDistance.options.add( new Option("3 "+mileRoute,5000) );
                                inputDistance.options.add( new Option("6 "+mileRoute,10000) );
                                inputDistance.options.add( new Option("8 "+mileRoute,13000) );
                                inputDistance.options.add( new Option("10 "+mileRoute,16000) );
                                inputDistance.options.add( new Option("15 "+mileRoute,24000) );
                                inputDistance.options.add( new Option("20 "+mileRoute,32000) );
                                inputDistance.options.add( new Option("25 "+mileRoute,40000) );
                                inputDistance.options.add( new Option("30 "+mileRoute,48000) );
                                inputDistance.options.add( new Option(L.localisation.get('search.targetDistanceCustom'),"custom") );
			} else {
				var kmRoute = L.localisation.get('search.kmRoute');
                                inputDistance.options.add( new Option(L.localisation.get('search.targetDistanceDirect'),0,true,true) );
                                inputDistance.options.add( new Option("5 "+kmRoute,5000) );
                                inputDistance.options.add( new Option("10 "+kmRoute,10000) );
                                inputDistance.options.add( new Option("13 "+kmRoute,13000) );
                                inputDistance.options.add( new Option("15 "+kmRoute,15000) );
                                inputDistance.options.add( new Option("20 "+kmRoute,20000) );
                                inputDistance.options.add( new Option("30 "+kmRoute,30000) );
                                inputDistance.options.add( new Option("40 "+kmRoute,40000) );
                                inputDistance.options.add( new Option("50 "+kmRoute,50000) );
                                inputDistance.options.add( new Option(L.localisation.get('search.targetDistanceCustom'),"custom") );
			}
			if (existingIndex >= 0) {
				inputDistance.selectedIndex = existingIndex;
			} else{
				inputDistance.selectedIndex = 1;
			}
		},

		_createGeocoder: function(i) {
			var geocoder = this.options.createGeocoderElement(this._waypoints[i], i, this._waypoints.length, this.options);
			geocoder
			.on('delete', function() {
				if (i > 0 || this._waypoints.length > 2) {
					this.spliceWaypoints(i, 1);
				} else {
					this.spliceWaypoints(i, 1, new Waypoint());
				}
			}, this)
			.on('moveup', function() {
				if (i <= 0) return;
				var wp = this._waypoints[i-1];
				this._waypoints[i-1] = this._waypoints[i];
				this._waypoints[i] = wp;
				this.spliceWaypoints(i,0);
			}, this)
			.on('movedown', function() {
				if (i >= this._waypoints.length - 1) return;
				var wp = this._waypoints[i+1];
				this._waypoints[i+1] = this._waypoints[i];
				this._waypoints[i] = wp;
				this.spliceWaypoints(i,0);
			}, this)
			.on('geocoded', function(e) {
				this._updateMarkers();
				this._fireChanged();
				this._focusGeocoder(i + 1);
				this.fire('waypointgeocoded', {
					waypointIndex: i,
					waypoint: e.waypoint
				});
			}, this)
			.on('reversegeocoded', function(e) {
				this.fire('waypointreversegeocoded', {
					waypointIndex: i,
					waypoint: e.waypoint
				});
			}, this);

			return geocoder;
		},

		_updateGeocoders: function() {
			var elems = [],
				i,
			    geocoderElem;

			for (i = 0; i < this._geocoderElems.length; i++) {
				this._geocoderContainer.removeChild(this._geocoderElems[i].getContainer());
			}

			for (i = this._waypoints.length - 1; i >= 0; i--) {

				// Only show geocoders for (1) the first waypoint on a RT, or (2) first and last WP on target distance P2P
				// Setting visible = true also causes reverse geocoding to occur
				if ((this.getRoundTrip() && i > 0) || (this.getTargetDistance() > 0 && i > 0 && i < this._waypoints.length - 1)) {
					this._waypoints[i].options.visible = false;
				} else {
					this._waypoints[i].options.visible = true;
				}

				geocoderElem = this._createGeocoder(i);

				// Add roundtrip class
				if (this.getRoundTrip()) {
					L.DomUtil.addClass(geocoderElem.getContainer(),'round-trip');
				}

				// Hide geocoder if the above is triggered
				if (!this._waypoints[i].options.visible) {
					geocoderElem.getContainer().style.display = 'none';
				}

				// radio buttons and add waypoint button go first
				this._geocoderContainer.insertBefore(geocoderElem.getContainer(), this._geocoderContainer.firstChild);
				//this._geocoderContainer.insertBefore(geocoderElem.getContainer(), this._geocoderContainer.childNodes[2]);
				elems.push(geocoderElem);
			}

			this._geocoderElems = elems.reverse();
		},

		_removeMarkers: function() {
			var i;
			if (this._markers) {
				for (i = 0; i < this._markers.length; i++) {
					if (this._markers[i]) {
						this._map.removeLayer(this._markers[i]);
					}
				}
			}
			this._markers = [];
		},

		_updateMarkers: function() {
			var i,
			    m;

			if (!this._map) {
				return;
			}

			this._removeMarkers();

			//for (i = 0; i < this._waypoints.length; i++) {
			for (i = this._waypoints.length-1; i >= 0; i--) {
				if (this._waypoints[i].latLng) {
					m = this.options.createMarker(i, this._waypoints[i], this._waypoints.length);
					if (m) {
						m.addTo(this._map);
						if (this.options.draggableWaypoints) {
							this._hookWaypointEvents(m, i);
						}
					}
				} else {
					m = null;
				}
				this._markers.push(m);
			}
		},

		_fireChanged: function() {
			this._waypointRevision = (this._waypointRevision || 0) + 1;
			this.fire('waypointschanged', {waypoints: this.getWaypoints()});

			if (arguments.length >= 2) {
				this.fire('waypointsspliced', {
					index: Array.prototype.shift.call(arguments),
					nRemoved: Array.prototype.shift.call(arguments),
					added: arguments
				});
			}
		},

		_hookWaypointEvents: function(m, i, trackMouseMove) {
			var eventLatLng = function(e) {
					return trackMouseMove ? e.latlng : e.target.getLatLng();
				},
				dragStart = L.bind(function(e) {
					// SC addition
					if (this.options.clickToAddPoint) {
						disableClickToAddPoint();
					}
					this.fire('waypointdragstart', {index: i, latlng: eventLatLng(e)});
				}, this),
				drag = L.bind(function(e) {
					this._waypoints[i].latLng = eventLatLng(e);
					this.fire('waypointdrag', {index: i, latlng: eventLatLng(e)});
				}, this),
				dragEnd = L.bind(function(e) {
					// SC addition
					if (this.options.clickToAddPoint) {
						setTimeout(L.Util.bind(function() {
							enableClickToAddPoint();
						}, this), 10);
					}
					// Switch to P2P if editing a RT or TD route
					if (control._selectedRoute && control._selectedRoute.inputOptions.targetDistance > 0) {
						control.getPlan().switchToP2P();
					}

					this._waypoints[i].latLng = eventLatLng(e);
					this._waypoints[i].name = '';
					if (this._geocoderElems) {
						this._geocoderElems[i].update(true);
					}
					this.fire('waypointdragend', {index: i, latlng: eventLatLng(e)});
					this._fireChanged();
				}, this),
				mouseMove,
				mouseUp;

			if (trackMouseMove) {
				mouseMove = L.bind(function(e) {
					this._markers[i].setLatLng(e.latlng);
					drag(e);
				}, this);
				mouseUp = L.bind(function(e) {
					this._map.dragging.enable();
					this._map.off('mouseup', mouseUp);
					this._map.off('mousemove', mouseMove);
					dragEnd(e);
				}, this);
				this._map.dragging.disable();
				this._map.on('mousemove', mouseMove);
				this._map.on('mouseup', mouseUp);
				dragStart({latlng: this._waypoints[i].latLng});
			} else {
				m.on('dragstart', dragStart);
				m.on('drag', drag);
				m.on('dragend', dragEnd);
			}
		},

		dragNewWaypoint: function(e) {
			// SC: prevent people clicking on the line to insert a new WP if the map is locked
			if (this.getPreventClickEdits()) return;

			// Switch to P2P if editing a RT or TD route
			if (control._selectedRoute && control._selectedRoute.inputOptions.targetDistance > 0) {
				control.getPlan().switchToP2P();
			}

			var newWpIndex = e.afterIndex + 1;
			if (this.options.routeWhileDragging) {
				this.spliceWaypoints(newWpIndex, 0, e.latlng);
				this._hookWaypointEvents(this._markers[newWpIndex], newWpIndex, true);
			} else {
				this._dragNewWaypoint(newWpIndex, e.latlng);
			}
		},

		_dragNewWaypoint: function(newWpIndex, initialLatLng) {
			var wpOpts = { straightLines: this.options.straightLines ? true : false };
			var planRevision = this._waypointRevision || 0;
			var wp = new Waypoint(initialLatLng, null, wpOpts),
				prevWp = this._waypoints[newWpIndex - 1],
				nextWp = this._waypoints[newWpIndex],
				marker = this.options.createMarker(newWpIndex, wp, this._waypoints.length + 1),
				lines = [],
				draggingEnabled = this._map.dragging.enabled(),
				mouseMove = L.bind(function(e) {
					var i,
						latLngs;
					if (marker) {
						marker.setLatLng(e.latlng);
					}
					for (i = 0; i < lines.length; i++) {
						latLngs = lines[i].getLatLngs();
						latLngs.splice(1, 1, e.latlng);
						lines[i].setLatLngs(latLngs);
					}

					L.DomEvent.stop(e);
				}, this),
				mouseUp = L.bind(function(e) {
					var i;
					if (marker) {
						this._map.removeLayer(marker);
					}
					for (i = 0; i < lines.length; i++) {
						this._map.removeLayer(lines[i]);
					}
					this._map.off('mousemove', mouseMove);
					this._map.off('mouseup', mouseUp);
					try {
						// A route response or another edit can invalidate the drag's index.
						if (planRevision === (this._waypointRevision || 0)) {
							this.spliceWaypoints(newWpIndex, 0, e.latlng);
						}
					} finally {
						if (draggingEnabled) this._map.dragging.enable();
						if (this.options.clickToAddPoint) {
							setTimeout(L.Util.bind(function() {
								enableClickToAddPoint();
							}, this), 10);
						}
						L.DomEvent.stop(e);
					}
				}, this),
				i;

			// SC addition
			if (this.options.clickToAddPoint) {
				disableClickToAddPoint();
			}

			if (marker) {
				marker.addTo(this._map);
			}

			for (i = 0; i < this.options.dragStyles.length; i++) {
				if (prevWp && prevWp.latLng && nextWp && nextWp.latLng) {
					lines.push(L.polyline([prevWp.latLng, initialLatLng, nextWp.latLng],
						this.options.dragStyles[i]).addTo(this._map));
				}
			}

			if (draggingEnabled) {
				this._map.dragging.disable();
			}

			this._map.on('mousemove', mouseMove);
			this._map.on('mouseup', mouseUp);
		},

		_focusGeocoder: function(i) {
			if (this._geocoderElems[i]) {
				this._geocoderElems[i].focus();
			} else {
				document.activeElement.blur();
			}
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./geocoder-element":52,"./waypoint":61}],61:[function(_dereq_,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null);

	module.exports = L.Class.extend({
		options: {
			straightLines: false
		},
		initialize: function(latLng, name, options) {
			L.Util.setOptions(this, options);
			this.latLng = L.latLng(latLng);
			this.name = name;
		}
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[53]);
